import BaseEntity from "./base.entity";

class InvoicesBilling extends BaseEntity {
  constructor(params) {
    super(params);

    if (!!params) {
      this.dueDate = params.due_date;
      this.description = params.items[0].description;
      this.invoiceUrl = params.secure_url;
    }
  }

  defaultParams() {
    return {
      id: "",
      due_date: "",
      items: [],
      secure_url: "",
      status: ""
    };
  }

  getServiceObject() {
    return {
      id: this.id,
      dueDate: this.due_date,
      description: this.items[0].description,
      invoiceUrl: this.secure_url,
      status: this.status
    };
  }
}

export default InvoicesBilling;



// WEBPACK FOOTER //
// ./src/core/entity/invoices-billing.entity.js